import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { enumeratorClient } from "config/axios";
import PATHS from "config/paths";
import { QueryKeys } from "config/query-keys";
import { RequestOtpPayload } from "./dto";

export const passwordOtpRequest = (data: RequestOtpPayload): Promise<{}> => {
  return enumeratorClient.httpClient.post(PATHS.enumerator.changePassword.requestOtp, data);
};

export const useEnumeratorPasswordOtpRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    onSuccess: async (data, __, ___) => {
      await queryClient.invalidateQueries({ queryKey: [QueryKeys.ENUMERATOR] });
      notification.success({
        message: "Otp Sent",
        description: "Otp is successfully sent to the given email.",
      });
    },

    mutationFn: passwordOtpRequest,
  });
};
